export default __webpack_public_path__ + "simple-map-500-e1599ca6173896f3d3ac94e9c2cdbe25.png";